/**
 * Service layer — the v2 milestone checklist templates (sheet 4 part two, step 3;
 * docs/CHECKLIST_PORT.md). Talks to /api/checklist-templates only. Templates → Milestone reads and
 * writes through here; Airtable's Checklist Item Templates table is no longer touched for milestones.
 */

async function authToken() {
  if (typeof window === 'undefined') return null
  for (let i = 0; i < 20; i++) {
    if (typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* not ready */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}
async function post(body) {
  const token = await authToken()
  const res = await fetch('/api/checklist-templates', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || ('Request failed: ' + res.status))
  return json
}

/**
 * `kind` is 'milestone' (typeId = a Deliverable Type's Airtable id) or 'sheet' (typeId = a Drawing
 * Sheet Template's Airtable id) — the two bridge keys the v2 template tables carry.
 */
export function listV2TemplateItems(typeId, kind = 'milestone') { return post({ action: 'list', kind, typeId }).then(r => r.items || []) }
export function addV2TemplateItem(typeId, name, summary, kind = 'milestone', drawingReleases) { return post({ action: 'add', kind, typeId, name, summary, drawingReleases }).then(r => r.item) }
export function updateV2TemplateItem(id, patch, kind = 'milestone') { return post({ action: 'update', kind, id, ...patch }).then(r => r.item) }
export function removeV2TemplateItem(id, kind = 'milestone') { return post({ action: 'remove', kind, id }) }
export function reorderV2TemplateItems(ids, kind = 'milestone') { return post({ action: 'reorder', kind, ids }) }
/** What "Sync" would do: { liveParents, newItems, orphaned }. Milestones: open unposted ones on v2. Sheets: every sheet on v2 for this template. */
export function analyzePushV2(typeId, kind = 'milestone') { return post({ action: 'analyzePush', kind, typeId }) }
export function doPushV2(typeId, kind = 'milestone') { return post({ action: 'doPush', kind, typeId }) }
